import { db } from "../../firebase/firebase";
import { collection, addDoc, serverTimestamp, doc, setDoc, Timestamp } from "firebase/firestore";
import { sendMessageInterface, MessageInterface } from './dto';

const sendMessage = async ({
  sender,
  recipient,
  jobId,
  companyName,
  jobTitle,
  status,
  text
}: sendMessageInterface): Promise<MessageInterface> => {

    const messageRef = await addDoc(collection(db, "messages"), {
        sender,
        recipient,
        jobId,
        participants: [sender, recipient],
        companyName,
        jobTitle,
        status,
        text,
        timestamp: serverTimestamp(),
    });


    const messageDocRef = doc(db, "messages", messageRef.id);
    await setDoc(messageDocRef, { id: messageRef.id }, { merge: true });

    return {
        id: messageRef.id,
        jobId,
        sender,
        recipient,
        participants: [sender, recipient],
        companyName,
        jobTitle,
        status,
        text,
        timestamp: Timestamp.now()
    };
};

export default sendMessage;